import { createCustomEnum } from "./customEnum";

const UserRoles = createCustomEnum({
	Executive: {
		value: 1,
		name: "Executive",
		displayName: "Executive",
	},
	DirectorAgentRelations: {
		value: 4,
		name: "DirectorAgentRelations",
		displayName: "Director Agent Relations",
	},
	InsideSalesManagerBusinessDevelopment: {
		value: 6,
		name: "InsideSaleManagerBusinessDevelopment",
		displayName: "Inside Sales Manager/Business Development",
	},
	InsideSales: {
		value: 7,
		name: "InsideSales",
		displayName: "Inside Sales",
	},
	OutsideAgent: {
		value: 8,
		name: "OutsideAgent",
		displayName: "Outside Agent",
	},
	ReferralPartner: {
		value: 9,
		name: "ReferralPartner",
		displayName: "Referral Partner",
	},
	DirectorBoarding: {
		value: 10,
		name: "DirectorBoarding",
		displayName: "Director Boarding",
	},
	RiskAnalystUnderwriter: {
		value: 13,
		name: "RiskAnalystUnderwriter",
		displayName: "Risk Analyst/Underwriter",
	},
	DirectorRiskCredit: {
		value: 14,
		name: "DirectorRiskCredit",
		displayName: "Director Risk/Credit",
	},
	AgentRelations: {
		value: 131,
		name: "AgentRelations",
		displayName: "Agent Relations",
	},
	Boarding: {
		value: 917,
		name: "Boarding",
		displayName: "Boarding",
	},
	DirectorTechSupport: {
		value: 918,
		name: "DirectorTechSupport",
		displayName: "Director Tech Support",
	},
	DirectorCustomerService: {
		value: 920,
		name: "DirectorCustomerService",
		displayName: "Director Customer Service",
	},
	CustomerService: {
		value: 921,
		name: "CustomerService",
		displayName: "Customer Service",
	},
	AgentOfficeManager: {
		value: 922,
		name: "AgentOfficeManager",
		displayName: "Agent office manager",
	},
	AgentOfficeAdmin: {
		value: 923,
		name: "AgentOfficeAdmin",
		displayName: "Agent office admin",
	},
	DirectorFinance: {
		value: 926,
		name: "DirectorFinance",
		displayName: "Director Finance",
	},
	Finance: {
		value: 392,
		name: "Finance",
		displayName: "Finance",
	},
	TechSupport: {
		value: 919,
		name: "TechSupport",
		displayName: "Tech Support",
	},
	ResidualsUser: {
		value: 21,
		name: "ResidualsUser",
		displayName: "Residuals User",
	},
});

export default UserRoles;
